import React from 'react'
import Div100vh from 'react-div-100vh'
import QrReader from 'react-qr-reader'
import BarcodeScan from '../../../components/shared/BarcodeScan'
import ArrowSvg from '../../../../assets/images/arrow-back.svg'
import './QrScan.scss'

function QrScan ({ handleScan, onClose, title, subtitle, barcode }) {

  return (
    <Div100vh className='mobile-container'>
      <div className='qr-title'>
        <div onClick={() => onClose()}>
          <img src={ArrowSvg} alt='flecha' />
        </div>
        <p>{title}</p>
      </div>
      <div className='qr-subtitle'>
        <p>{subtitle}</p>
      </div>
      <div className='qrscan-container'>
        {
          barcode ? (
            <BarcodeScan onDetectCode={handleScan} />
          ) : (
            <QrReader
              delay={300}
              onError={() => alert('Debe permitir que este sitio web acceda a la cámara')}
              onScan={handleScan}
              style={{ width: '100%'}}
            />
          )
        }
      </div>
    </Div100vh>
  )

}

export default QrScan
